import { render, staticRenderFns } from "./shrimp-quality-modal.vue?vue&type=template&id=5a6dedd2&scoped=true&"
import script from "./shrimp-quality-modal.vue?vue&type=script&lang=js&"
export * from "./shrimp-quality-modal.vue?vue&type=script&lang=js&"
import style0 from "./shrimp-quality-modal.vue?vue&type=style&index=0&id=5a6dedd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6dedd2",
  null
  
)

export default component.exports